import axios from 'axios';
import {config} from './config';

const {baseURL,dictionary} = config;
//export const api = axios.create({baseURL:'http://localhost:9091'});
export const api = axios.create({baseURL});

//const dictionaryId = '600e7ed210a6d967c4e5ddea';

const dictionaryId = dictionary;

export const getRandomPuzzle = async (rows,cols)=>{
    const args = {
        dictionaryId,
        rows,
        cols
    };

    const puzzleUser = localStorage.getItem('puzzle-user');

    //console.log('local storage, puzzle-user',puzzleUser);

    if(puzzleUser){
        args.user = puzzleUser;
    }

    const {data} = await api.post('/random-puzzle',args);

    //console.log('random puzzle data',data);

    localStorage.setItem('puzzle-user',data.puzzleUser);

    return data;
};

export const checkAnswer = async (puzzleId,answer,row,col,direction)=>{

    const {data} = await api.post('/check-answer',{puzzleId,answer,row,col,direction});

    return data;

};

export const checkAnswers = async (answers)=>{

    const {data} = await api.post('/check-answers',answers);

    return data;

};

export const skipPuzzle = async (puzzle,user) =>{
    try{
        await api.post('/skip-puzzle',{puzzle,user});
    }catch(e){
        console.log('error on puzzle skip!',e);
    }
};

export const completePuzzle = async (puzzle,user,answers)=>{

    //answers[0].word = 'ASDF'; to test at least 1 wrong answer
    
    try {
      const { data } = await api.post("/complete-puzzle", {
        puzzle,
        user,
        //answers:answers.slice(1), to test non matching answer count
        answers
      });

      if (data && data.success) {
        console.log("Puzzle complete");
      } else {
        console.log("Puzzle cannot be completed, check your answers");
      }

      return data;
    } catch (e) {
        console.log('puzzle complete error',e);
    }

    

};

export const getAvailablePuzzleDimensions = async ()=>{

    const {data} = await api.get(`/available-puzzle-dimensions/${dictionaryId}`);

    return data;
    
};

export const getLastOpenPuzzle = async (userId)=>{
    
    const {data} = await api.get(`/last-open-puzzle/${userId}/${dictionaryId}`);

    return data;

};